// extracted by mini-css-extract-plugin
export default {"containerr":"_39DRE","mobile":"_3VJJy","loader":"D33j9","button":"_7Uy5d","loading":"_3kwu4","full":"_2qJZA","rounded":"_3IX4q"};